export default {
  props: {
    optionValueProp: {
      type: [String, Function],
      default: 'value',
    },
    optionLabelProp: {
      type: [String, Function],
      default: 'name',
    },
  },
  methods: {
    /**
     *
     * @param {string|object} option
     * @return {string|null}
     */
    getOptionValue(option) {
      if (typeof option === 'string') {
        return option;
      }

      if (this.optionValueProp instanceof Function) {
        return this.optionValueProp(option);
      }

      if (
        typeof option === 'object' &&
        this.optionValueProp &&
        option[this.optionValueProp] !== undefined
      ) {
        return option[this.optionValueProp];
      }

      return null;
    },
    /**
     *
     * @param {string|object} option
     * @return {string|null}
     */
    getOptionLabel(option) {
      if (this.optionLabelProp instanceof Function) {
        return this.optionLabelProp(option);
      }

      if (
        typeof option === 'object' &&
        this.optionLabelProp &&
        option[this.optionLabelProp] !== undefined
      ) {
        return option[this.optionLabelProp];
      }

      // Fallback to option value
      return this.getOptionValue(option);
    },
  },
};
